export default {
  showMoney: (state, cents) => {
    fx.rates   = window.Currency.rates;
    var base   = state.currency.base;
    var code   = state.currency.code;
    var amount = (cents/100).toFixed(2);

    var original = amount;

    var symbol = '$';
    if(code == 'EUR') symbol = '€';
    if(code == 'GBP') symbol = '₤';
    if(code == 'YEN') symbol = '¥';

    if(base !== code) {
      amount = fx.convert(amount, {from: code, to: base}).toFixed(2);
    }

    // amount = amount.replace('.00','');

    return `${symbol}${amount}`;// ${code}`
  },
  showPrice: (state,view, data, code) => {
    var showMoney          = view.currency.showMoney;
    var formatted_original = false;
    var formatted_price    = showMoney(state, data.price,code);//.toString().replace('.00', '').replace('.0', '');

    //If original price exists
    if(data.original != null && data.original > data.price) formatted_original = showMoney(state,data.original);

    if(formatted_original) {
      return `<span class="sale">${formatted_price}</span> <span class="original">${formatted_original}</span> `;
    } 

    return `${formatted_price}`;
  },
  showCurrency: (view, code) => {
    var formatSymbol = view.currency.formatSymbol;

    return `${formatSymbol(code)} ${code}`
  },
  formatSymbol: (code) => {
    var symbol = '$';
    if(code == 'EUR') symbol = '€';
    if(code == 'GBP') symbol = '₤';
    if(code == 'YEN') symbol = '¥';
    return symbol;
  },
  formatCurrencies: (state,view) => {
    var current_code = state.currency.code;
    var showCurrency = view.currency.showCurrency;
    var codes = ['USD', 'GBP', 'EUR', 'CAD'];

    return _.chain(codes)
      .map((c) => {
        return {
          code: c,
          name: showCurrency(view,c)
        }
      })
      .filter((c) => {
        return c.code !== current_code;
      })
      .value()
  }
}